import { render } from "./OrdersReporting.vue?vue&type=template&id=632207d8&scoped=true"
import script from "./OrdersReporting.vue?vue&type=script&lang=js"
export * from "./OrdersReporting.vue?vue&type=script&lang=js"

import "./OrdersReporting.vue?vue&type=style&index=0&id=632207d8&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632207d8"]])

export default __exports__